import qs from 'qs'
import { getUrlPath } from '@yuanfudao/metis-unified-login'

export function getSchoolSearch() {
  const search = `?redirectUrl=${encodeURIComponent(encodeURIComponent(window.location.href))}`
  const s = window.location.hash.split('?')[1]
  if (s && qs.parse(s).redirectUrl) {
    return `?${s}`
  }
  if (['/embed/403'].some((path) => getUrlPath() === path)) {
    return ''
  }
  return search
}